import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import CallCompanyNoteTaking from "../../components/CallCompanyNoteTaking";
import Grid from "@mui/material/Grid";
import "./style.css";

import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { read } from "./api.js";
import { readEmpty } from "./apiEmpty.js";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import CloseIcon from "@mui/icons-material/Close";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Chip from "@mui/material/Chip";

import { Select, MenuItem, Typography } from "@mui/material";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InputAdornment from "@mui/material/InputAdornment";

const LIMIT = 10;

function normalizeRows(response) {
  const payload =
    response?.data !== undefined && !Array.isArray(response)
      ? response.data
      : response;

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.results)) return payload.results;

  return [];
}

function getContractList(post) {
  if (Array.isArray(post?.kontrak)) return post.kontrak;
  if (Array.isArray(post?.kontrakList)) return post.kontrakList;
  if (post?.kontrak) return [post.kontrak];
  return [];
}

function getMainContract(post) {
  const list = getContractList(post);
  return list[0] || null;
}

function normalizePostForUseData(post) {
  const kontrakList = getContractList(post);
  const mainContract = kontrakList[0] || null;

  return {
    ...(post || {}),
    kontrak: mainContract,
    kontrakList,
  };
}

function getCompanyName(post) {
  const contract = getMainContract(post);

  return (
    post?.company?.namaPerusahaan ||
    post?.company?.NamaPerusahaan ||
    post?.companyByKontrak?.[0]?.namaPerusahaan ||
    contract?.CompanyName ||
    contract?.NamaPT ||
    ""
  );
}

function getClientName(post) {
  const contract = getMainContract(post);

  return (
    post?.klien?.Nama ||
    post?.klien?.nama ||
    contract?.KlienNama ||
    contract?.NamaKlien ||
    ""
  );
}

function getClientPhone(post) {
  const phone = post?.klien?.Phone;

  if (Array.isArray(phone)) return phone[0] || "";
  return phone || "";
}

function getContractStatus(startDate, endDate, terminateStat) {
  if (terminateStat === "Yes") return "Expired";

  if (!startDate || !endDate) return "-";

  const currentDate = new Date();
  const starting = new Date(startDate);
  const ending = new Date(endDate);

  if (Number.isNaN(starting.getTime()) || Number.isNaN(ending.getTime())) {
    return "-";
  }

  if (currentDate < starting) return "Belum Mulai";
  if (currentDate >= starting && currentDate <= ending) return "Aktif";
  return "Expired";
}

function getStatusColor(status) {
  if (status === "Aktif") return "success";
  if (status === "Belum Mulai") return "warning";
  if (status === "Expired") return "error";
  return "default";
}

function getRecipientStatus(post) {
  const contract = getMainContract(post);
  const companyName = getCompanyName(post);
  const clientName = getClientName(post);
  const clientPhone = getClientPhone(post);

  if (!companyName) {
    return {
      ready: false,
      block: true,
      reason: "Nama perusahaan tidak ditemukan. Periksa data company / kontrak.",
    };
  }

  if (!clientName && !contract?.KlienID && !post?.klien?._id) {
    return {
      ready: false,
      block: true,
      reason: "Nama klien / KlienID tidak ditemukan. Periksa data kontrak.",
    };
  }

  if (post?.recipientReady === false) {
    return {
      ready: false,
      block: false,
      reason:
        post?.missingReason ||
        "Data klien / nomor WhatsApp belum lengkap. Backend akan cek ulang saat simpan.",
    };
  }

  if (!clientPhone) {
    return {
      ready: false,
      block: false,
      reason: "Nomor WhatsApp belum terlihat di frontend. Backend akan cek ulang dari database.",
    };
  }

  return {
    ready: true,
    block: false,
    reason: "",
  };
}

function buildUseDataPayload(useData) {
  const contract = getMainContract(useData);
  const kontrakList = getContractList(useData);

  return {
    ...(useData || {}),

    companyId:
      useData?.companyId ||
      useData?.company?._id ||
      contract?.CompanyID ||
      "",

    klienId:
      useData?.klienId ||
      useData?.klien?._id ||
      contract?.KlienID ||
      "",

    kontrakId:
      useData?.kontrakId ||
      contract?._id ||
      "",

    company: useData?.company || null,
    klien: useData?.klien || null,
    kontrak: contract || null,
    kontrakList,
  };
}

function getErrorMessage(error) {
  const serverData = error?.response?.data;

  if (typeof serverData === "string") return serverData;

  return (
    serverData?.message ||
    serverData?.error ||
    serverData?.details?.message ||
    error?.message ||
    "Gagal menyimpan call / mengirim WhatsApp."
  );
}

export default function CreatePost() {
  const [tanggalKejadian, setTanggalKejadian] = useState(new Date());

  const [skip, setSkip] = useState(0);
  const [posts, setPosts] = useState([]);
  const [isEnd, setIsEnd] = useState("Loading...");
  const [query, setQuery] = useState("");

  const [categorias, setCategorias] = useState([]);
  const [address1, setAddress1] = useState("semua");

  const [searchThis, setSearchThis] = useState("Perusahaan");
  const [statusnya, setStatusnya] = useState("Aktif");
  const [khusus, setKhusus] = useState("");

  const [loadingList, setLoadingList] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [pageError, setPageError] = useState("");

  const [useData, setUseData] = useState(null);
  const [openNewMail, setOpenNewMail] = useState(false);

  const [penelpon, setPenelpon] = useState("");
  const [mencari, setMencari] = useState("");
  const [noTelpPenelpon, setNoTelpPenelpon] = useState("");
  const [tujuan, setTujuan] = useState("");

  const [saving, setSaving] = useState(false);
  const [dialogError, setDialogError] = useState("");
  const [dialogSuccess, setDialogSuccess] = useState("");
  const [progressText, setProgressText] = useState("");

  const requestIdRef = useRef(0);

  const selectedCompanyName = getCompanyName(useData);
  const selectedClientName = getClientName(useData);
  const selectedClientPhone = getClientPhone(useData);
  const selectedContract = getMainContract(useData);

  const getCategorias = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/addressOptions`
      );

      setCategorias(response.data?.pilihanAlamat || []);
    } catch (error) {
      console.error(error);
      setPageError(
        error.response?.data?.message ||
          error.message ||
          "Gagal mengambil pilihan lokasi."
      );
    }
  }, []);

  const fetchPosts = useCallback(
    async ({ reset = false, nextSkip = 0 } = {}) => {
      const requestId = ++requestIdRef.current;

      setLoadingList(true);
      setPageError("");

      try {
        const cleanQuery = query.trim();

        const response = cleanQuery
          ? await read(nextSkip, cleanQuery, searchThis, address1, statusnya, khusus)
          : await readEmpty(nextSkip, cleanQuery, searchThis, address1, statusnya, khusus);

        if (requestId !== requestIdRef.current) return;

        const rows = normalizeRows(response);

        setPosts((prev) => (reset ? rows : [...prev, ...rows]));
        setHasMore(rows.length >= LIMIT);

        if (rows.length === 0 || rows.length < LIMIT) {
          setIsEnd("Selesai...");
        } else {
          setIsEnd("");
        }
      } catch (error) {
        console.error(error);

        if (requestId !== requestIdRef.current) return;

        setPageError(
          error.response?.data?.message ||
            error.message ||
            "Gagal mengambil data call."
        );
        setIsEnd("Gagal load data.");
      } finally {
        if (requestId === requestIdRef.current) {
          setLoadingList(false);
        }
      }
    },
    [query, searchThis, address1, statusnya, khusus]
  );

  useEffect(() => {
    getCategorias();
  }, [getCategorias]);

  useEffect(() => {
    setSkip(0);
    fetchPosts({ reset: true, nextSkip: 0 });
  }, [fetchPosts]);

  const handleChangeAddress = (event) => {
    setAddress1(event.target.value);
    setSkip(0);
  };

  const handleChangeStatus = (event) => {
    setStatusnya(event.target.value);
    setSkip(0);
  };

  const handleChangeKhusus = (event) => {
    setKhusus(event.target.value);
    setSkip(0);
  };

  const changeSearchThis = (value) => {
    setSearchThis(value);
    setSkip(0);
  };

  const handleSearch = (event) => {
    setQuery(event.target.value);
    setSkip(0);
  };

  const handleScroll = (e) => {
    const { offsetHeight, scrollTop, scrollHeight } = e.target;

    if (loadingList || !hasMore) return;

    if (offsetHeight + scrollTop >= scrollHeight - 80) {
      const nextSkip = posts.length;
      setSkip(nextSkip);
      fetchPosts({ reset: false, nextSkip });
    }
  };

  const resetCallForm = () => {
    setPenelpon("");
    setMencari("");
    setNoTelpPenelpon("");
    setTujuan("");
    setDialogError("");
    setDialogSuccess("");
    setProgressText("");
  };

  const newMail = (post) => {
    setPageError("");
    setDialogError("");
    setDialogSuccess("");

    const normalizedPost = normalizePostForUseData(post);
    const recipientStatus = getRecipientStatus(normalizedPost);

    if (recipientStatus.block) {
      setPageError(recipientStatus.reason);
      return;
    }

    setUseData(normalizedPost);

    /**
     * Important:
     * This pre-fills the template's "mencari" field with the company name.
     * Admin can still edit it inside CallCompanyNoteTaking if the component allows it.
     */
    setMencari(getCompanyName(normalizedPost) || getClientName(normalizedPost) || "");

    setPenelpon("");
    setNoTelpPenelpon("");
    setTujuan("");

    setOpenNewMail(true);
  };

  const closeNewMail = () => {
    if (saving) return;

    setUseData(null);
    setOpenNewMail(false);
    resetCallForm();
  };

  const simpanCall = async () => {
    if (saving) return;

    setDialogError("");
    setDialogSuccess("");

    const missing = [];

    if (!String(penelpon || "").trim()) {
      missing.push("Penelpon");
    }

    if (!String(mencari || "").trim()) {
      missing.push("Mencari / Nama Perusahaan");
    }

    if (!selectedCompanyName) {
      missing.push("Nama Perusahaan");
    }

    if (!selectedClientName && !selectedContract?.KlienID && !useData?.klien?._id) {
      missing.push("Nama Klien / KlienID");
    }

    if (missing.length > 0) {
      setDialogError(`Ada data kosong: ${missing.join(", ")}`);
      return;
    }

    setSaving(true);
    setProgressText("Mengirim WhatsApp via Cekat...");

    try {
      const dataCall = {
        penelpon: String(penelpon || "").trim(),
        mencari: String(mencari || "").trim(),
        noTelpPenelpon: String(noTelpPenelpon || "").trim(),
        tujuan: String(tujuan || "").trim(),
      };

      const payload = {
        tipe: "SharedCall",
        dataCall,
        tanggalKejadian,
        statNotify: "Yes",
        useData: buildUseDataPayload(useData),
        searchThis,
        lokasi:
          selectedContract?.LokasiKontrak ||
          address1 ||
          "",
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/saveCall`,
        payload
      );

      setProgressText("");
      setDialogSuccess(
        response.data?.message ||
          "Call tersimpan dan WhatsApp berhasil dikirim."
      );

      await fetchPosts({ reset: true, nextSkip: 0 });

      setTimeout(() => {
        closeNewMail();
      }, 800);
    } catch (error) {
      console.error(error);
      setProgressText("");
      setDialogError(getErrorMessage(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Grid container>
      <Dialog
        open={openNewMail}
        fullWidth
        maxWidth="xl"
        onClose={(event, reason) => {
          if (saving) return;
          if (reason === "backdropClick") return;
          closeNewMail();
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <Button onClick={closeNewMail} disabled={saving} autoFocus>
            <CloseIcon />
          </Button>
        </DialogTitle>

        <DialogContent>
          <Alert severity={getRecipientStatus(useData).ready ? "success" : "warning"} sx={{ mb: 2 }}>
            <b>Tujuan Notifikasi WhatsApp</b>
            <br />
            Perusahaan: {selectedCompanyName || "-"}
            <br />
            Klien: {selectedClientName || "-"}
            <br />
            WhatsApp: {selectedClientPhone || "Akan dicek ulang oleh backend"}
            <br />
            Kontrak: {selectedContract?.kontrakNum || selectedContract?._id || "-"}
          </Alert>

          {getRecipientStatus(useData).reason && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              {getRecipientStatus(useData).reason}
            </Alert>
          )}

          {progressText && (
            <Alert severity="info" sx={{ mb: 2 }}>
              <Box display="flex" alignItems="center">
                <CircularProgress size={18} sx={{ mr: 1 }} />
                {progressText}
              </Box>
            </Alert>
          )}

          {dialogError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {dialogError}
            </Alert>
          )}

          {dialogSuccess && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {dialogSuccess}
            </Alert>
          )}

          <CallCompanyNoteTaking
            setTanggalKejadian={setTanggalKejadian}
            simpanCall={simpanCall}
            useData={useData}
            tanggalKejadian={tanggalKejadian}
            searchThis={searchThis}
            closeNewMail={closeNewMail}
            penelpon={penelpon}
            setPenelpon={setPenelpon}
            mencari={mencari}
            setMencari={setMencari}
            noTelpPenelpon={noTelpPenelpon}
            setNoTelpPenelpon={setNoTelpPenelpon}
            tujuan={tujuan}
            setTujuan={setTujuan}
            saving={saving}
            error={dialogError}
          />
        </DialogContent>

        <DialogActions>
          <Grid style={{ marginRight: "auto" }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <MobileDatePicker
                disabled={saving}
                views={["year", "month", "day"]}
                inputFormat="dd/MM/yyyy"
                value={tanggalKejadian}
                onChange={(event) => setTanggalKejadian(event)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <InputAdornment position="end">
                          <CalendarMonthIcon />
                        </InputAdornment>
                      ),
                      style: { height: "35px" },
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Button
            variant="outlined"
            color="inherit"
            onClick={closeNewMail}
            disabled={saving}
          >
            Batal
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={simpanCall}
            disabled={saving}
          >
            {saving ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                <Typography>Menunggu Cekat...</Typography>
              </>
            ) : (
              <Typography>Simpan dan Notifikasi</Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Grid item xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
        <LeftMenu />
      </Grid>

      <Grid item xl={10.8} lg={10.6} md={10.4} sm={8.8}>
        <Grid
          className="boxshadowclass"
          position="fixed"
          width="98%"
          xs={12}
          zIndex="100"
          opacity="1"
        >
          <Header
            judul="Call Baru"
            isi="Halaman untuk memasukkan panggilan telepon baru"
          />
        </Grid>

        <Grid sx={{ mt: 15 }} />

        <Grid sx={{ pl: 15 }}>
          <Grid container xs={12} sx={{ mb: 10 }}>
            <Grid item xs={4}>
              <Typography>
                <b>Status:</b>
              </Typography>

              <FormControl component="fieldset">
                <RadioGroup value={statusnya} onChange={handleChangeStatus}>
                  <FormControlLabel
                    value="Aktif"
                    control={<Radio />}
                    label="Aktif"
                  />
                  <FormControlLabel
                    value="Non-Aktif"
                    control={<Radio />}
                    label="Expired"
                  />
                  <FormControlLabel
                    value="Semua"
                    control={<Radio />}
                    label="Semua"
                  />
                  <FormControlLabel
                    value="Belum-Mulai"
                    control={<Radio />}
                    label="Belum Mulai"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              <Typography>
                <b>Lokasi:</b>
              </Typography>

              <Select
                value={address1}
                whiteSpace="normal"
                onChange={handleChangeAddress}
                sx={{ minWidth: 260 }}
              >
                {categorias.map((categoria) => (
                  <MenuItem key={categoria} multiline value={categoria}>
                    {categoria}
                  </MenuItem>
                ))}

                <MenuItem multiline value="semua">
                  Semua Lokasi
                </MenuItem>
              </Select>
            </Grid>

            <Grid item xs={4}>
              <Typography>
                <b>Tipe Kontrak:</b>
              </Typography>

              <FormControl component="fieldset">
                <RadioGroup value={khusus} onChange={handleChangeKhusus}>
                  <FormControlLabel value="" control={<Radio />} label="Semua" />
                  <FormControlLabel
                    value="Virtual Office"
                    control={<Radio />}
                    label="Virtual Office Only"
                  />
                  <FormControlLabel
                    value="Private Office"
                    control={<Radio />}
                    label="Private Office Only"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container sx={{ mb: 2 }} spacing={2}>
            <Grid item xs={2}>
              <Select
                fullWidth
                value={searchThis}
                onChange={(event) => changeSearchThis(event.target.value)}
              >
                <MenuItem value="Perusahaan">Nama PT</MenuItem>
                <MenuItem value="Klien">Nama Orang</MenuItem>
              </Select>
            </Grid>

            <Grid item xs={5}>
              <TextField
                fullWidth
                value={query}
                onChange={handleSearch}
                placeholder={
                  searchThis === "Perusahaan"
                    ? "Cari nama PT..."
                    : "Cari nama klien..."
                }
              />
            </Grid>
          </Grid>

          {pageError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {pageError}
            </Alert>
          )}

          <Grid container alignItems="center" justifyContent="center">
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              {loadingList && (
                <Box sx={{ width: "100%" }}>
                  <LinearProgress />
                </Box>
              )}

              <TableContainer
                sx={{ maxHeight: 500, minHeight: 440 }}
                className="min-h-screen h-screen overflow-scroll"
                onScroll={handleScroll}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nama Perusahaan</TableCell>
                      <TableCell>Nama Klien</TableCell>
                      <TableCell>WhatsApp</TableCell>
                      <TableCell>Tipe Kontrak</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Keterangan</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {posts?.map((post, index) => {
                      const normalizedPost = normalizePostForUseData(post);
                      const contract = getMainContract(normalizedPost);
                      const companyName = getCompanyName(normalizedPost);
                      const clientName = getClientName(normalizedPost);
                      const clientPhone = getClientPhone(normalizedPost);
                      const recipientStatus = getRecipientStatus(normalizedPost);

                      const status = getContractStatus(
                        contract?.TanggalMulai,
                        contract?.TanggalBerakhir,
                        contract?.termintateStat
                      );

                      const key =
                        contract?._id ||
                        `${normalizedPost?.company?._id || "company"}-${
                          normalizedPost?.klien?._id || "klien"
                        }-${index}`;

                      return (
                        <TableRow
                          key={key}
                          hover
                          onClick={() => newMail(normalizedPost)}
                          sx={{
                            cursor: "pointer",
                            opacity: recipientStatus.block ? 0.65 : 1,
                          }}
                        >
                          <TableCell>
                            <p>{companyName || "-"}</p>
                          </TableCell>

                          <TableCell>
                            <p>
                              {clientName || (
                                <span style={{ color: "red" }}>
                                  KLIEN BELUM TERHUBUNG
                                </span>
                              )}
                            </p>
                          </TableCell>

                          <TableCell>
                            <p>{clientPhone || "-"}</p>
                          </TableCell>

                          <TableCell>
                            <p>{contract?.TipeKontrak || "-"}</p>
                          </TableCell>

                          <TableCell>
                            <Chip
                              size="small"
                              label={status}
                              color={getStatusColor(status)}
                            />
                          </TableCell>

                          <TableCell>
                            {recipientStatus.ready ? (
                              <Chip
                                size="small"
                                color="success"
                                label="Siap kirim"
                              />
                            ) : (
                              <Alert severity="warning" sx={{ py: 0 }}>
                                {recipientStatus.reason}
                              </Alert>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}

                    {!loadingList && posts.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={6}>
                          <Typography align="center" sx={{ py: 4 }}>
                            Tidak ada data.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}

                    {isEnd && posts.length > 0 && (
                      <TableRow>
                        <TableCell colSpan={6}>
                          <Typography align="center" sx={{ py: 2 }}>
                            {isEnd}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}